/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PerformanceVestingMetricType {
    MOIC = 'MOIC',
    XIRR = 'XIRR',
    MOIC_AND_XIRR = 'MOIC_AND_XIRR',
}
